import { ALLOWED_THIRD_PARTIES } from 'services/utils/constants/third-parties'
import {
  GHS_URL,
  GEORGE_URL,
  DOT_COM_URL,
  BABY_CLUB_URL,
} from 'services/utils/constants/site-urls'

export const WM_CONSUMER_ID =
  window.location.host === 'www.asda.com'
    ? '44be1aee-3d2f-4bf7-96b0-0358b5f8a539'
    : 'fa1f9bc8-7b03-4c44-a063-370888dd8a4f'

export const getSourceLabel = (origin) => {
  switch (origin) {
    case 'gi':
      return 'Back to shop'
    case 'george':
      return 'Back to shop'
    case 'sng_mobile':
      return 'Back to app'
    case 'asda':
      return 'Home'
    case 'btc':
      return 'Back to club'
    default:
      return 'Home'
  }
}

export const getRedirectUrl = (origin) => {
  switch (origin) {
    case 'george':
      return GEORGE_URL
    case 'btc':
      return BABY_CLUB_URL
    case 'gi':
      return GHS_URL
    case 'asda':
    default:
      return DOT_COM_URL
  }
}

export const getAriaLabel = (origin) => {
  switch (origin) {
    case 'george':
      return 'George.com homepage'
    case 'asda':
      return 'Asda.com homepage'
    case 'btc':
      return 'Baby club homepage'
    case 'gi':
      return 'Asda Groceries homepage'
    case 'creditcard':
      return 'Asda credit card'
    default:
      return 'Asda.com homepage'
  }
}

const originMap = {
  gi: 'GHS',
  george: 'George',
  sng_kiosk: 'SngKiosk',
  dotCom: 'GHS',
}

export const getService = (origin) => {
  switch (origin) {
    case 'giftcards':
      return 'giftcards'
    case 'creditcard':
      return 'creditcard'
    case 'ssomobile':
        return 'ssomobile'
    default:
      const requestOrigin = ALLOWED_THIRD_PARTIES.includes(origin.toLowerCase())
        ? 'gi'
        : origin
      return originMap[requestOrigin] || ''
  }
}

export const getTermsAcceptance = origin => [
  {
    service: getService(origin),
    acceptance: 'y',
  },
]

export const getThemeString = origin =>
  `theme-${(originMap[origin] || originMap.gi).toLowerCase()}`

export const DEFAULT_DOB = '01/01/1900'
